export default __webpack_public_path__ + "static/media/Paper Icon.5444f8fe.svg";